


import { ISelectOption } from "../dtos/SelectOptionDto";
enum HiringChangesCodes {
        Item1 = 0,
        Item2 = 1,
        Item3 = 2,
        Item4 = 3,
        Item5 = 4,
        Item6 = 5,
         
}

export class HiringChangesCodes_class {

public static enum = HiringChangesCodes;

  public static readonly enumByText : { [key : string ]: number} = {
    ['Item1']: 0,
    ['Item2']: 1,
    ['Item3']: 2,
    ['Item4']: 3,
    ['Item5']: 4,
    ['Item6']: 5,
    
  };
  public static readonly enumByNumber : { [key : number ]: string} = {
    [0]: "1- No Change",
    [1]: "2- Hours Changed",
    [2]: "3- Job Duties Changed",
    [3]: "4- Rate of Pay Changed",
    [4]: "5- Changed Job Location",
    [5]: "6- Not Listed Above",
    
  };

  public static readonly enumAsSelectOptions:Array<ISelectOption<number>> = [
  {value: 0, text: "1- No Change"},
  {value: 1, text: "2- Hours Changed"},
  {value: 2, text: "3- Job Duties Changed"},
  {value: 3, text: "4- Rate of Pay Changed"},
  {value: 4, text: "5- Changed Job Location"},
  {value: 5, text: "6- Not Listed Above"},
  ]
}

